import { CardMembership } from './card-membership'
import { MappableModel } from './mappable-model'
import { Mapper } from '../services/mapper.service'
import { Persona } from './persona'
import { Organization } from './organization'
import { MembershipNumber } from './membership-number'

export class Card extends MappableModel {
  public id: number
  public memberships: CardMembership[]
  public organization: Organization
  public persona: Persona
  public number: MembershipNumber
  public updated_at: Date | null


  public deserialize(): void {
    this.memberships = Mapper.asArray<CardMembership>(this.memberships, CardMembership)
    this.organization = Mapper.as<Organization>(this.organization, Organization)
    this.persona = Mapper.as<Persona>(this.persona, Persona)
    this.number = Mapper.as<MembershipNumber>(this.number, MembershipNumber)
    this.updated_at = this.updated_at ? new Date(this.updated_at) : null
  }
}
